"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var webfontloader_1 = __importDefault(require("webfontloader"));
function loadFontsIntoBrowser(userFilesUrl, account) {
    return function (fonts) {
        var config = {
            classes: false,
        };
        var googleFonts = fonts.filter(function (f) { return f.vendor === "GoogleFonts"; });
        if (googleFonts.length) {
            config.google = {
                families: fonts.map(function (f) { return "".concat(f.name, ":300,400,700,400italic"); }),
            };
        }
        var typeKit = fonts.find(function (f) { return f.vendor === "Typekit"; });
        if (typeKit != null) {
            config.typekit = {
                id: typeKit.typekitId,
            };
        }
        var hostedWebfonts = fonts.filter(function (f) { return f.vendor === "HostedWebfont"; });
        if (hostedWebfonts.length) {
            config.custom = {
                families: hostedWebfonts.map(function (f) { return f.name; }),
                urls: hostedWebfonts.map(function (f) { return "".concat(userFilesUrl, "/").concat(account.assetKey, "/fonts/").concat(f.filename, "/").concat(f.filename, ".css"); }),
            };
        }
        webfontloader_1.default.load(config);
        return config;
    };
}
exports.default = loadFontsIntoBrowser;
